import { createFileRoute } from '@tanstack/react-router';
import { RunPage } from '@/features/payroll/runs/run-page';
import { guardRoute } from '@/lib/route-guards';

export const Route = createFileRoute('/_app/payroll_/runs_/$runId')({
  beforeLoad: ({ context }) => {
    guardRoute(context.auth, '/payroll/runs');
  },
  component: RunRoute,
});

function RunRoute() {
  const { runId } = Route.useParams();
  // A new key per run so filters, paging and drafts start fresh.
  return <RunPage key={runId} runId={runId} />;
}
